import React, { useEffect, useState } from 'react'
import userImage from '../../assets/images/User1.png';
import { createUserService,getUserService, resetPasswordService, updateUserService } from '../../services/user.service';
import { createSharePercentService , getSharePercentService } from '../../services/sharepercent.service';
import { getGameTypeService } from '../../services/gametype.service';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";

const User = () => {

  const [showNewModal, setShowNewModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [userData, setUserData] = useState([]);
  const [sharePercents, setSharePercents] = useState([]);
  const [gameTypeData, setGameTypeData] = useState([]);
  const [errors, setErrors] = useState({});
  const [resetModal, setResetModal] = useState(false);
  const [resetPassword, setResetPassword] = useState({})
  const [inputData, setInputData] = useState({
    userId: '',
    name: '',
    username: '',
    password: '',
    role: 'user'
  })

  const dispatch = useDispatch();

  const showNew = () => {
    setShowNewModal(!showNewModal);
    setEdit(false);
    setInputData({
      name: '',
      username: '',
      password: '',
      role: 'user'
    })
    setErrors({})
  }

  useEffect(() => {
    let resultArray = gameTypeData.map(item => ({
      gameTypeId: item.gameTypeId,
      gameType: item.gameType,
      percent: 0,
      status: false

    }));
    setSharePercents(resultArray);
  },[showNewModal])

  const handleChange = (e) => {
    setInputData({
      ...inputData,
      [e.target.name]: e.target.value,
      [e.target.username]: e.target.value,
      [e.target.password]: e.target.value,
      [e.target.role]: 'user'
    })
  }

  const handleEditClick= (user) => {
    setInputData(user)
    setShowNewModal(true);
    setEdit(true);

    const controller = new AbortController();
    const signal = controller.signal;

    getSharePercents(user.userId, signal);

    return () => {
      controller.abort();
    }
  }

  const handleResetClick = (user) => {
    setResetModal(!resetModal);
    setResetPassword({
      ...resetPassword,
      userId: user.id
    })
  }

  const handleSubmitResetPassword = (event) => {
    event.preventDefault();
    if(resetPassword.confirmPassword === resetPassword.newPassword) {
        resetAction();
      }
  }

  const validate = () => {
    let errors = {};

    if(!inputData.name) {
      errors.name = 'Name is required';
    }
    if(!inputData.username) {
      errors.username = 'Username is required';
    }else if (inputData.username.length < 3) {
      errors.username = 'Username must be at least 3 characters long';
    }

    if(!edit) {
      if(!inputData.password) {
        errors.password = 'Password is required';
      }else if (inputData.password.length < 6) {
        errors.password = 'Password must be at least 6 characters long';
      }
    }

    return errors;
  }

  const getUserData = async (signal) => {

    try {
        dispatch(setIsLoading(true))
        const result = await getUserService(signal);
        if(result.data) {
          setUserData(result.data)
        }
    } catch (error) {
        const errorMessage =
            error?.response?.data?.error?.includes('streaming buffer')
                ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                : error?.response?.data?.message || error?.message;

        dispatch(
            setToastMessage({
                message: errorMessage,
                type: "error",
            })
        );
    } finally {
        dispatch(setIsLoading(false))
    }
  }

  const getGameTypeData = async (signal) => {

    try {
        dispatch(setIsLoading(true))
        const result = await getGameTypeService(signal);
        if(result.data) {
          setGameTypeData(result.data)

        }
    } catch (error) {
        const errorMessage =
            error?.response?.data?.error?.includes('streaming buffer')
                ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                : error?.response?.data?.message || error?.message;

        dispatch(
            setToastMessage({
                message: errorMessage,
                type: "error",
            })
        );
    } finally {
        dispatch(setIsLoading(false))
    }
  }
  // Get Portion Data from API
  const getSharePercents = async (userId, signal) => {
    dispatch(setIsLoading(true))
    try {
      const result = await getSharePercentService(userId, signal);
      if(result.data) {
        const resultArray = gameTypeData.map(item2 => {
          const match = result.data.find(item1 => item1.gameType === item2.gameType);

          return {
            key: item2.gameTypeId,
            gameTypeId: item2.gameTypeId,
            gameType: item2.gameType,
            percent: match ? match.percent : 0, // Use default value if no match
            status: match ? match.status : false // Use default value if no match
          };
        });
          setSharePercents(resultArray);
      }
    } catch (error) {
        const errorMessage =
            error?.response?.data?.error?.includes('streaming buffer')
                ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                : error?.response?.data?.message || error?.message;

        dispatch(
            setToastMessage({
                message: errorMessage,
                type: "error",
            })
        );
    } finally {
      dispatch(setIsLoading(false))
    }
  }

  useEffect(() => {
    const controller = new AbortController();
      const signal = controller.signal;
      getGameTypeData(signal);
      getUserData(signal);

      return () => {
        controller.abort();
      }
  },[]);

  let handleSubmit = (event) => {
    event.preventDefault();
    dispatch(setIsLoading(true))
    const validateErrors = validate();

    if(Object.keys(validateErrors).length === 0) {
      createAction();
    }
    else {
      setErrors(validateErrors);
    }
  }

  const resetAction = async () => {
    dispatch(setIsLoading(true))

    try{
      let result;
      result = await resetPasswordService({
        ...resetPassword
      })

      if(result.data) {
        setShowNewModal(false);
      }
    }
    catch (error) {
      dispatch(
        setToastMessage({
          message: error?.response?.data?.message || error?.message,
          type: "error",
        })
      );
    }
    finally {
     dispatch(setIsLoading(false))
    }
  }

  const handleShareChange = (id, event) => {
      const { name, value } = event.target;
      const floatValue = parseFloat(value);

      setSharePercents(prevData =>
          prevData.map(share =>
              share.gameTypeId === id
              ? {
                  ...share,
                  [name]: isNaN(floatValue) ? floatValue : value
                } : share
          )
      );
  };

  const handleStatusChange = (id, event) => {
      const status = event.target.checked;

      setSharePercents(prevData =>
        prevData.map(share =>
            share.gameTypeId === id
            ? {
                ...share,
                status: status
              } : share
        )
      );
  };


  const createAction = async () => {
    dispatch(setIsLoading(true))
    try {
      let result;

      if(edit) {
              let filter = sharePercents.map(el => ({
                gameTypeId: el.gameTypeId,
                status: el.status,
                percent: parseFloat(el.percent)
              }));

              result = await updateUserService({
                userId: inputData.userId,
                name: inputData.name,
                username: inputData.username,
                role: inputData.role,

                sharePercents: filter

              })
              if(result){
                    // setUserData(userData.map(obj => obj.userId === result.data.userId ?
                    //   result.data
                    // : obj));
                    // setShowNewModal(false);
                    // setEdit(false);
                    dispatch(
                      setToastMessage({
                          message: "Update Success",
                          type: "success",
                      })
                    );
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000)
              }
          } else {

                let filter = sharePercents.map(el => ({
                  gameTypeId: el.gameTypeId,
                  status: el.status,
                  percent: el.percent
                }));

                result = await createUserService({
                  name: inputData.name,
                  username: inputData.username,
                  password: inputData.password,
                  role: inputData.role,

                  sharePercents: filter

                })

                if(result) {
                  userData.unshift(result.adminUserData);
                  showNew();
                }
          }
    }
    catch (error) {
      dispatch(
        setToastMessage({
          message: error?.response?.data?.message || error?.message,
          type: "error",
        })
      );
    }
    finally {
     dispatch(setIsLoading(false))
    }
  }

  // UserData Table Mapping
  const userDataList = ( userData && userData.map((user, index) => {
    return (
      <tr key={user.userId} className='border-b-2'>
        <th className='text-userText p-4'>{index + 1}</th>
        <th className='text-userText p-4'>{user.name}</th>
        <th className='text-userText p-4'>{user.username}</th>
        <th className='text-userText p-4'>{user.role}</th>
        <th>
          <button className={`bg-primary p-2 w-20 text-white rounded shadow-md font-semibold ${user.role === 'adminstrator' ? 'hidden' : 'block'}`}
            onClick={() => handleEditClick(user)}
          >
            Edit
          </button>
        </th>
        <th>
          <button
            onClick={() => handleResetClick(user)}
            className={`bg-primary p-2 w-20 text-white rounded shadow-md font-semibold ${user.role === 'adminstrator' ? 'hidden' : 'block'}`}
          >
            Reset
          </button>
        </th>
      </tr>
    )
  }))

  // sharePercent Table Mapping
  const addedSharePercents = sharePercents.map((share) => {
    return(
      <div key={share.sharePercentId} className='flex justify-between items-center p-5 font-bold text-userText border-b-2 border-borderColor pe-10'>
          <input
              type="checkbox"
              name='status'
              checked={share.status}
              onChange={e => handleStatusChange(share.gameTypeId, e)}
              className='w-5'
          />
          <h1>{share.gameType}</h1>

          <div>
              <input
                  type="number"
                  name='percent'
                  className='w-20 py-1 text-right bg-bgColor outline-none rounded-sm'
                  value={share.percent}
                  onChange={e => handleShareChange(share.gameTypeId, e)}
              />
              <span className='ms-1'>%</span>
          </div>
      </div>
    )
  })

  return (
    <div className='h-[88vh]'>
      <div className='text-sm hidden sm:block'>
        {/* logo and User */}
        <div className='flex items-center w-[95%] m-auto pb-4 pt-2'>
          <img src={userImage} className='w-8 me-3'/>
          <div className='font-bold text-userText mt-0.5'>/ User</div>
        </div>
        {/* main div */}
        <div className='bg-white w-[95%] m-auto'>
          {/* addUser button */}
          <div className='p-6 border-b-2 border-borderColor'>
            <button className='bg-primary text-center p-3 text-white w-48 font-bold rounded-md' onClick={() => setShowNewModal(true)}>Add New User</button>
          </div>

          {showNewModal && (
            <div className=''>
              <div className='grid md:grid-cols-2 sm:grid-cols-1 border-b-2 border-borderColor'>
                {/* start form */}
                <div className='p-10'>
                  <form className='grid grid-rows-[3fr, 1fr] md:grid-cols-2' onSubmit={handleSubmit}>
                    <div className='flex flex-col'>
                      <input
                          type='text'
                          placeholder='Display Name'
                          name='name'
                          value={inputData.name}
                          onChange={handleChange}
                          className='p-3 bg-bgColor mt-3 outline-none font-bold rounded-md'/>
                      {errors.name && <p className='text-red text-xs font-bold'>{errors.name}</p>}
                      <input
                          onChange={handleChange}
                          value={inputData.username}
                          name='username'
                          type='text'
                          placeholder='Username'
                          className='p-3  bg-bgColor mt-3 outline-none font-bold rounded-md'/>
                      {errors.username && <p className='text-red text-xs font-bold'>{errors.username}</p>}
                      <input
                          onChange={handleChange}
                          value={inputData.password}
                          name='password'
                          type='password'
                          disabled={edit}
                          placeholder='Password'
                          className='p-3  bg-bgColor mt-3 outline-none font-bold rounded-md'/>
                      {errors.password && <p className='text-red text-xs font-bold'>{errors.password}</p>}
                      {/* <select
                            className='p-3 bg-bgColor font-bold rounded-md outline-none mt-3'
                            value={inputData.role}
                            onChange={handleChange}
                            name='role'>
                        <option className='' value='admin'>admin</option>
                        <option className='' value='user'>user</option>
                      </select> */}
                    </div>
                    <div className='text-white flex flex-col font-bold ms-5 md:mt-32 mt-10 w-40'>

                      <button type="submit"
                      className="px-10 py-3 mb-3 text-white bg-primary rounded-lg"
                      >
                        {edit ? "Update" : "Create"}
                      </button>
                      <button type='button' className='px-10 py-3 mb-3 text-white bg-buttonRed rounded-lg
                      ' onClick={showNew}>
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
                {/* end form */}
                {/* <div className='pe-20 mb-8'>
                  <h1 className='text-buttonRed font-bold border-b-2 border-borderColor px-5 py-8'>The share added portion</h1>
                  <div className='max-h-64 overflow-y-auto'>
                  {sharePercents && (addedSharePercents)}
                  </div>
                </div> */}
              </div>
            </div>
          )}
          {/*  */}
          <div className='w-[95%] m-auto'>
            <table className='w-[90%] m-auto'>
              <thead>
                <tr className='text-userText border-b-2 border-borderColor h-20'>
                  <th className='w-[5%]'>No.</th>
                  <th className='w-[35%]'>Display Name</th>
                  <th className='w-[30%]'>Username</th>
                  <th className='w-[30%]'>Role</th>
                  <th className='w-[8%]'>Edit</th>
                  <th className='w-[8%]'>Reset Password</th>
                </tr>
              </thead>
              <tbody className='max-h-72 overflow-y-auto'>
                {userData && (userDataList)}
              </tbody>
              <tfoot className='h-10'></tfoot>
            </table>
            {resetModal && (
                            <form onSubmit={handleSubmitResetPassword} className="fixed inset-0 bg-textcol bg-opacity-30 backdrop-blur-sm flex justify-center items-center">
                                <div className="flex flex-col justify-center w-[360px] h-[300px] bg-white rounded-lg">
                                    <h1 className='ml-10 font-bold mb-2'>Reset Password</h1>
                                    <div className='flex flex-col mx-auto justify-center items-center w-[80%]'>
                                        <input
                                        type="password"
                                        onChange={(e) => setResetPassword({...resetPassword, oldPassword: e.target.value})}
                                        value={resetPassword.oldPassword}
                                        className='w-[210px] bg-textbgcol px-3 py-2 rounded-md font-semibold mt-3 outline-none'
                                        placeholder='Old Password' />
                                        <input
                                        type="password"
                                        onChange={(e) => setResetPassword({...resetPassword, newPassword: e.target.value})}
                                        value={resetPassword.newPassword}
                                        className='w-[210px] bg-textbgcol px-3 py-2 rounded-md font-semibold mt-3 outline-none'
                                        placeholder='New Password' />
                                        {errors.newPassword && resetModal && <p className='text-red text-xs font-bold'>{errors.newPassword}</p>}
                                        <input
                                        type="password"
                                        onChange={(e) => setResetPassword({...resetPassword, confirmPassword: e.target.value})}
                                        value={resetPassword.confirmPassword}
                                        className='w-[210px] bg-textbgcol px-3 py-2 rounded-md font-semibold mt-3 outline-none'
                                        placeholder='confirm Password' />
                                        {errors.confirmPassword && resetModal && <p className='text-red text-xs font-bold'>{errors.confirmPassword}</p>}
                                    </div>


                                    <div className="flex justify-end items-center w-[80%] h-[35px] mt-5 select-none">
                                        <button className="px-5 py-2 mr-2 text-white bg-primary rounded-lg cursor-pointer" type='submit'
                                        >Save</button>
                                        <button className="px-5 py-2 mr-2 text-white bg-primary rounded-lg cursor-pointer" onClick={() => setResetModal(false)}>Cancel</button>
                                    </div>
                                </div>
                            </form>
                        )}
          </div>
        </div>
        <div className='h-14'></div>
      </div>
      <div className='flex justify-center items-center h-[70vh] sm:hidden'>
          <div className='flex justify-center items-center text-md font-semibold text-slate-500'>
              Create User _ only for wide screen
          </div>
      </div>
    </div>
  )
}

export default User;
